fragment OnboardingChecklistItem on OnboardingChecklistItem {
    key
    title
    subtitle
    isComplete
}
